module.exports = __webpack_public_path__ + "static/media/logoBody.6112e0c3.svg";